import { useAppContext } from '@lib/app-context';
import { useRouter } from 'next/router';

import {
  EuiButtonEmpty,
  EuiContextMenuItem,
  EuiContextMenuPanel,
  EuiPopover,
  EuiText,
  EuiThemeProvider,
  EuiIcon,
  EuiHorizontalRule,
} from '@elastic/eui';
import { FC, useState } from 'react';

export const CongressBadge: FC = () => {
  const { user, chosenCongress, setChosenCongress } = useAppContext();
  const [isPopoverOpen, setPopover] = useState(false);
  const router = useRouter();

  const closePopover = (): void => {
    setPopover(false);
  };

  const activeCongresses = user.congresses.filter(congress => congress.active);

  const badge = (
    <EuiThemeProvider colorMode="dark">
      <EuiButtonEmpty
        iconType="arrowDown"
        size="xs"
        color="text"
        style={{ padding: '0 6px' }}
        iconSide="right"
        onClick={() => setPopover(p => !p)}>
        <EuiText size="s">
          {chosenCongress == null
            ? 'Choose a congress...'
            : chosenCongress.name}
        </EuiText>
      </EuiButtonEmpty>
    </EuiThemeProvider>
  );

  return (
    <EuiPopover
      button={badge}
      isOpen={isPopoverOpen}
      closePopover={closePopover}
      panelPaddingSize="none"
      anchorPosition="downRight">
      <EuiContextMenuPanel>
        {activeCongresses.map(congress => (
          <EuiContextMenuItem
            key={congress.id}
            icon={
              <EuiIcon
                type={chosenCongress?.id === congress.id ? 'check' : 'empty'}
              />
            }
            onClick={() => {
              setChosenCongress(congress);
              closePopover();
              router.push('/');
            }}>
            <EuiText size="s">{congress.name}</EuiText>
          </EuiContextMenuItem>
        ))}
        {user.admin && (
          <>
            <EuiHorizontalRule margin="none" />
            <EuiContextMenuItem
              key="see-all"
              icon={<EuiIcon type="boxesHorizontal" />}
              onClick={() => {
                closePopover();
                router.push('/choose-congress');
              }}>
              <EuiText size="s">See all</EuiText>
            </EuiContextMenuItem>
            <EuiContextMenuItem
              key="manage"
              icon={<EuiIcon type="gear" />}
              onClick={() => {
                closePopover();
                router.push('/manage/congresses');
              }}>
              <EuiText size="s">Manage</EuiText>
            </EuiContextMenuItem>
          </>
        )}
      </EuiContextMenuPanel>
    </EuiPopover>
  );
};
